import useForm from './useForm';
import TextField from 'components/TextField';
import styles from './blogs.module.scss';
import ProductImage from 'components/ProductImage';
import Button from 'components/Button';
import {Controller} from 'react-hook-form';
import classNames from 'classnames';
import CkeditorField from 'components/Ckeditor/Ckeditor';
import Typography from 'components/Typography';
import {BlogStatus} from 'pages/Blogs/BlogsList/useBlogs';

function Index() {
  const {loading, setImage, control, errors, createHandler, setFieldValue} =
    useForm();

  return (
    <>
      <div className={styles.status}>
        <Typography style={{marginBottom: 4, fontSize: 16}} variant="p">
          Published:
        </Typography>
        <BlogStatus
          id={''}
          active={true}
          onChangeStatus={(value) => {
            setFieldValue('is_active', value);
          }}
        />
      </div>
      <div className={styles.container}>
        <div className={styles.left}>
          <Controller
            control={control}
            name="title"
            rules={{required: 'Required'}}
            render={({field}) => (
              <TextField
                label="Title"
                placeholder="Title"
                value={field.value}
                wrapperClass={styles.title}
                onChange={field.onChange}
                error={errors.title?.message}
              />
            )}
          />
          <Controller
            control={control}
            name="content"
            rules={{required: 'Required'}}
            render={({field}) => (
              <CkeditorField
                field={field}
                form={{
                  errors,
                }}
              />
            )}
          />
        </div>
        <div className={styles.right}>
          <Controller
            control={control}
            name="slug"
            rules={{required: 'Required'}}
            render={({field}) => (
              <TextField
                label="Slug"
                placeholder="Slug"
                value={field.value}
                wrapperClass={styles.title}
                onChange={field.onChange}
                error={errors.slug?.message}
              />
            )}
          />
          <div style={{marginBottom: '8px'}}>Image:</div>
          <div
            className={classNames(styles.image, errors.image && styles.error)}
          >
            <Controller
              control={control}
              name="image"
              rules={{required: 'Required'}}
              render={({field}) => (
                <ProductImage
                  showDelete={true}
                  size="medium"
                  product={undefined}
                  onChange={(value) => {
                    setImage(value);
                    field.onChange(value);
                  }}
                />
              )}
            />
          </div>
          {errors.image && (
            <div className={styles.errorMessage}>{errors.image.message}</div>
          )}

          <Button
            loading={loading}
            onClick={createHandler}
            color="blue"
            style={{width: '100%', marginTop: 30}}
          >
            Create
          </Button>
        </div>
      </div>
    </>
  );
}

export default Index;
